function ratingSearch(searchQuery) {
    var searchRegexp,
        searchForm = $('.rating__search-form'),
        searchListItem = $('<li/>', {
            class: 'search-result__item'
        });

    searchForm.find('.search-form__clear').addClass('hidden');
    searchForm.find('.search-result').empty().removeClass('hidden');

    if ((searchQuery == '') || (searchQuery == ' ')) {
        searchForm.find('.search-result').empty();
    }
    else {
        $('.js-search-container .js-search-field').each(function () {
            var userName = $(this).text(),
                userId = $(this).parents('.rating__person').data('user-id'),
                searchResult;

            searchForm.find('.search-form__clear').removeClass('hidden');
            searchRegexp = new RegExp(searchQuery, 'ig');
            searchResult = userName.match(searchRegexp);
            if (searchResult) {
                searchListItem.clone().text(userName).attr('data-user-id', userId).appendTo(searchForm.find('.search-result'));
            }
        });

        if (searchForm.find('.search-form__result .search-result__item').length === 0) {
            searchListItem.clone().text('Ничего не найдено').addClass('disabled').appendTo(searchForm.find('.search-result'));
        }
    }
}

function attendeesSearch(searchQuery) {
    var searchRegexp,
        searchForm = $('.attendees-search__form');

    searchForm.find('.search-form__clear').addClass('hidden');

    if ((searchQuery == '') || (searchQuery == ' ')) {
        $('.search-attendee').removeClass('hidden');
        $('.attendees-search__empty').addClass('hidden');
    }
    else {
        $('.attendees-search__list .js-search-field').each(function () {
            var userName = $(this).text(),
                searchResult;

            searchForm.find('.search-form__clear').removeClass('hidden');
            searchRegexp = new RegExp(searchQuery, 'ig');
            searchResult = userName.match(searchRegexp);

            if (searchResult) {
                $(this).parents('.search-attendee').removeClass('hidden');
                $('.attendees-search__empty').addClass('hidden');
            }
            else {
                $(this).parents('.search-attendee').addClass('hidden');
            }
        });

        if ($('.search-attendee').length == $('.search-attendee.hidden').length) {
            $('.search-attendee').addClass('hidden');
            $('.attendees-search__empty').removeClass('hidden');
        }
    }
}

$('body').on('input', '.rating__search-form .search-form__input', function () {
    var searchQuery = $(this).val();
    ratingSearch(searchQuery);
})

$('body').on('input', '.attendees-search__form .search-form__input', function () {
    var searchQuery = $(this).val();
    attendeesSearch(searchQuery);
})

// переключение между результатами поиска с помощью стрелок вверх/вниз
$('body').on('keyup', '.rating__search-form .search-form__input', function (event) {
    var keyCode = event.keyCode;

    if ((keyCode !== 40) && (keyCode !== 38) && (keyCode !== 13)) {
        return false;
    }
    // подсветка выбранного из поиска пользователя
    else if (keyCode == 13) {
        if (!$('.search-result__item').hasClass('disabled')){
            if ($('.search-result__item').hasClass('is-focus')) {
                event.preventDefault();
                $('.search-result__item.is-focus').trigger('click');
            }
        }
    }
    else {
        if ($('.search-form__result').find('.fast-search__result')) {
            if (keyCode == 40) {
                if ($('.search-result__item').hasClass('is-focus')) {
                    var focusEq = $('.search-result__item.is-focus').index();

                    if (focusEq === $('.search-result .search-result__item').length - 1) {
                        $('.search-result__item').eq(0).addClass('is-focus');
                        $('.search-result__item').eq(focusEq).removeClass('is-focus');
                    }
                    else {
                        $('.search-result__item').eq(focusEq + 1).addClass('is-focus');
                        $('.search-result__item').eq(focusEq).removeClass('is-focus');
                    }
                }
                else {
                    $('.search-result__item').eq(0).addClass('is-focus');
                }
            }
            if (keyCode == 38) {
                if ($('.search-result__item').hasClass('is-focus')) {
                    var focusEq = $('.search-result__item.is-focus').index();
                    $('.search-result__item').eq(focusEq - 1).addClass('is-focus');
                    $('.search-result__item').eq(focusEq).removeClass('is-focus');
                }
                else {
                    $('.search-result__item').eq(-1).addClass('is-focus');
                }
            }

        }
    }
})

$('body').on('keyup', '.attendees-search__form .search-form__input', function (event) {
    var keyCode = event.keyCode;

    if ((keyCode !== 40) && (keyCode !== 38) && (keyCode !== 13)) {
        return false;
    }
    // подсветка выбранного из поиска пользователя
    else if (keyCode == 13) {
        if (!$('.search-attendee').hasClass('disabled')){
            if ($('.search-attendee').hasClass('is-focus')) {
                event.preventDefault();
                $('.search-attendee.is-focus').trigger('click');
            }
        }
    }
    else {
        if (keyCode == 40) {
            if ($('.search-attendee').hasClass('is-focus')) {
                var focusEq = $('.search-attendee.is-focus').index();

                if (focusEq === $('.search-attendee').length - 1) {
                    $('.search-attendee').eq(0).addClass('is-focus');
                    $('.search-attendee').eq(focusEq).removeClass('is-focus');
                }
                else {
                    var nextElem = $('.search-attendee.is-focus').nextAll('.search-attendee:not(.hidden)').eq(0);
                    nextElem.addClass('is-focus');
                    $('.search-attendee').eq(focusEq).removeClass('is-focus');
                }
            }
            else {
                $('.search-attendee').eq(0).addClass('is-focus');
            }
        }
        else if (keyCode == 38) {
            if ($('.search-attendee').hasClass('is-focus')) {
                var focusEq = $('.search-attendee.is-focus').index(),
                    prevElem = $('.search-attendee.is-focus').prevAll('.search-attendee:not(.hidden)').eq(0);

                prevElem.addClass('is-focus');
                $('.search-attendee').eq(focusEq).removeClass('is-focus');
            }
            else {
                $('.search-attendee').eq(-1).addClass('is-focus');
            }
        }
    }
})

$('body').on('submit', '.search-form', function (event) {
    event.preventDefault();
    return false;
})

$('body').on('focus', '.rating__search-form .search-form__input', function () {
    var searchQuery = $(this).val();
    $(this).parents('.js-search-container').find('.search-result').removeClass('hidden');
    ratingSearch(searchQuery);
})

$('body').on('focus', '.attendees-search__form .search-form__input', function () {
    var searchQuery = $(this).val();
    $(this).parents('.js-search-container').find('.search-result').removeClass('hidden');
    attendeesSearch(searchQuery);
})

$('body').click(function(event) {
    if($(event.target).parents('.search-form').length == 0) {
        $('.search-result').addClass('hidden');
    }
})

// подсветка выбранного из поиска пользователя
$('body').on('click', '.search-result__item', function () {
    var userId = $(this).data('user-id'),
        userName = $(this).text(),
        userInRating = $('.rating__person[data-user-id=' + userId + ']');

    $('.rating__person').removeClass('rating__person_selected-user rating__person_prev-selected-user');
    userInRating.addClass('rating__person_selected-user');
    userInRating.prev().addClass('rating__person_prev-selected-user');
    $('.search-result').addClass('hidden');
    $('.search-form__input').val(userName);

    var ratingTableHeadHeight = 62;
    var scrollToUser = $('.rating-table__tbody').scrollTop() > 0 ? $('.rating-table__tbody').scrollTop() + userInRating.position().top - ratingTableHeadHeight : userInRating.position().top - ratingTableHeadHeight;
    $('.rating-table__tbody').stop().animate({
        scrollTop: scrollToUser
    }, 1000);
})

$('body').on('click', '.search-form__clear', function () {
    $(this).addClass('hidden');
    var parentSearchContainer = $(this).parents('.search-form');
    parentSearchContainer.find('.search-result').empty();
    parentSearchContainer.find('.search-form__input').val('');
    parentSearchContainer.find('.search-form__input').focus();
})